import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { screenSizes } from 'src/assets/styles/Literals';

export const adminTableStyles = css`
  background-color: white;
  padding: 20px 40px;
  border-radius: 10px;
  min-width: 100vw;
  margin: 0 auto;

  @media (min-width: ${screenSizes.laptop}) {
    min-width: 90vw;
  }

  @media (max-width: ${screenSizes.tablet}) {
    min-width: 95vw;
    padding: 10px;
  }

  .AdminTable__content {
    display: block;
  }

  table {
    border-collapse: collapse;
    width: 100%;
  }

  .leaderNameFilter {
    input {
      width: -webkit-fill-available;
    }
  }

  td,
  th {
    border: 1px solid #dddddd;
    text-align: left;
    padding: 0 6px;
  }

  tr:nth-child(even) {
    background-color: #dddddd;
  }

  @media only screen and (max-width: 900px) {
    padding: 10px;
    .active.tab {
      padding: 10px 0;
    }
  }
`;

export const adminTableNetworkStyles = css`
  .main-buttons {
    text-align: center;
  }

  &.comunidad-network {
    background-color: white;
    padding: 20px;
    margin: 35px;
    border-radius: 10px;
    .cards {
      i {
        font-size: 15px;
        margin: 0 5px 5px 0;
      }
      .description {
        font-size: 15px;
      }
    }
  }

  h2 {
    text-align: center;
  }

  p.salute {
    font-style: italic;
    font-size: 17px;
    margin: 0;
    color: rgb(126, 126, 126);
    &:first-of-type {
      margin-top: 10px;
    }
    &:last-of-type {
      margin-bottom: 10px;
    }
  }

  .options {
    p {
      margin: 5px 0;
    }
    > div {
      width: 48%;
      display: inline-block;
      padding: 0 5px;
      &.catalog {
        width: 90%;
      }
    }
    .search-query {
      margin-bottom: 20px;
      > div {
        width: 98%;
      }
    }
  }
`;

export const AdminTableSection = styled.section`
  ${adminTableStyles}
`;

export const AdminTableNetworkSection = styled(AdminTableSection)`
  ${adminTableNetworkStyles}
`;

export const AdminTableContent = styled.div`
  display: block;
`;

/** @deprecated Use AdminTableSection — kept for styled components that compose admin table styles */
export const AdminTableContentComponent = AdminTableContent;
